import React, { useState } from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Button } from '../components/ui/button';
import { Mail, Copy, Check, Clock } from 'lucide-react';
import { toast } from 'sonner';

export const ContactForm = () => {
  const [copied, setCopied] = useState(false);

  const handleCopyEmail = async () => {
    try {
      await navigator.clipboard.writeText('inquiry@archeanx.com');
      setCopied(true);
      toast.success('Email address copied to clipboard');
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      toast.error('Could not copy email. Please copy it manually.');
    }
  };

  return (
    <section id="contact" data-testid="contact-section" className="py-20 px-6 relative min-h-[500px]">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://static.prod-images.emergentagent.com/jobs/32261963-9d8c-4e92-9519-12d4f10bddcb/images/94570522be9fd02fba22f9077bbcf934298273db824ee3a89011e621017fd77f.png"
          alt="Aircraft inspection in hangar"
          className="w-full h-full object-cover opacity-30"
        />
        <div className="absolute inset-0 bg-white/30"></div>
      </div>

      <div className="container mx-auto max-w-5xl relative z-10">
        <div className="text-center space-y-4 mb-12">
          <Badge className="bg-orange-100 text-orange-700 border-orange-200">
            Request a Demo
          </Badge>
          <h2 className="text-4xl md:text-5xl font-bold text-black">Ready to Transform Your Operations?</h2>
          <p className="text-xl text-gray-700 max-w-2xl mx-auto">
            Reach out and our team will get back to you with a personalized demo.
          </p>
        </div>
        <div className="max-w-xl mx-auto">
          <Card className="border-gray-200 shadow-lg bg-white">
            <CardContent className="pt-10 pb-10 px-8 flex flex-col items-center text-center gap-5">
              <div className="w-14 h-14 rounded-full bg-orange-100 flex items-center justify-center">
                <Mail className="w-6 h-6 text-orange-600" />
              </div>
              <p className="text-gray-700 text-base">
                Inquire via email at
              </p>
              <a
                href="mailto:inquiry@archeanx.com"
                data-testid="contact-email-link"
                className="text-2xl font-bold text-black hover:text-orange-600 transition-colors"
              >
                inquiry@archeanx.com
              </a>
              <Button
                asChild
                data-testid="contact-email-btn"
                className="bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white mt-2"
              >
                <a href="mailto:inquiry@archeanx.com">Email Us</a>
              </Button>
              <div className="flex items-center gap-3">
                <Button
                  variant="outline"
                  size="sm"
                  data-testid="contact-copy-email-btn"
                  onClick={handleCopyEmail}
                  className="border-gray-300 text-gray-700 hover:border-orange-500 hover:text-orange-600"
                >
                  {copied ? (
                    <><Check className="w-4 h-4 mr-1.5" /> Copied</>
                  ) : (
                    <><Copy className="w-4 h-4 mr-1.5" /> Copy Email</>
                  )}
                </Button>
              </div>
              <div data-testid="response-time-note" className="flex items-center gap-1.5 text-sm text-gray-500 mt-1">
                <Clock className="w-3.5 h-3.5" />
                We typically reply within 24 hours
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};
